/** @jsxImportSource @emotion/react */
import { theme } from '@app/styles/theme'
import { css } from '@emotion/react'

export const rowStyles = css({
  cursor: 'pointer',
  userSelect: 'none',
  backgroundColor: theme.palette.action.hover,
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
})

export const cellStyles = css({
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(6),
})

export const labelStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
})

export const iconButtonStyles = css({
  padding: 0,
})

export const chipStyles = css({
  marginLeft: theme.spacing(1),
  height: theme.spacing(2.5),
})

export type BaseGroupRowProps = {
  label: string
  count?: number
  colSpan: number
  isExpanded: boolean
  onToggle: () => void
}
